import {useField, useFormikContext} from "formik";
import React from "react";

const NewsletterSignupInput = ({label, ...props}) => {

    const { submitForm } = useFormikContext();

    const handleSubmit = () => {
        console.log("handleSubmit")
        submitForm();
    }
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input>. We can use field meta to show an error
    // message if the field is invalid and it has been touched (i.e. visited)
    const [field, meta] = useField(props);
    return (
        <React.Fragment>
            <div className={"input-group-flex  " + (meta.touched && meta.error && " has-danger" || "")}>
                {/*<span className="input-group-btn">*/}
                {/*    <button type="submit"><i className="material-icons send"></i></button>*/}
                {/*    */}
                {/*</span>*/}
                <input type="text" className={"form-control text-xs " + (meta.touched && meta.error && "form-control-danger")} {...field} {...props} />
                <div className="input-group-append">
                    <button className="btn btn-light text-uppercase text-xxs" type="button" onClick={() => { handleSubmit(); }}>{label}</button>
                </div>
               
                {/*<small className="form-text text-muted">Example help text that remains unchanged.</small>*/}
            </div>
            {meta.touched && meta.error ? (
                <div className="form-control-feedback">
                    * {meta.error}
                </div>
            ) : null}
        </React.Fragment>
    );
};


const TextInput = ({label, ...props}) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input>. We can use field meta to show an error
    // message if the field is invalid and it has been touched (i.e. visited)
    const [field, meta] = useField(props);
    return (
        <React.Fragment>
            <div className={"form-group " + (meta.touched && meta.error && " has-danger" || "")}>
                <label htmlFor={props.id || props.name}>{label}</label>
                <input type="text" className={"form-control " + (meta.touched && meta.error && "form-control-danger")} {...field} {...props} />
                {meta.touched && meta.error ? (
                    <div className="form-control-feedback">
                        * {meta.error}
                    </div>
                ) : null}
                {/*<small className="form-text text-muted">Example help text that remains unchanged.</small>*/}
            </div>
        </React.Fragment>
    );
};

const TextArea = ({label, ...props}) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input>. We can use field meta to show an error
    // message if the field is invalid and it has been touched (i.e. visited)
    const [field, meta] = useField(props);
    return (
        <React.Fragment>
            <div className={"form-group " + (meta.touched && meta.error && " has-danger" || "")}>
                <label htmlFor={props.id || props.name}>{label}</label>
                <textarea className={"form-control " + (meta.touched && meta.error && "form-control-danger")} {...field} {...props} />
                {meta.touched && meta.error ? (
                    <div className="form-control-feedback">
                        * {meta.error}
                    </div>
                ) : null}
                {/*<small className="form-text text-muted">Example help text that remains unchanged.</small>*/}
            </div>
        </React.Fragment>
    );
}

const TextLabel = ({label, ...props}) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input>. We can use field meta to show an error
    // message if the field is invalid and it has been touched (i.e. visited)
    const [field, meta] = useField(props);
    return (
        <React.Fragment>
            <div className={"form-group " + (meta.touched && meta.error && " has-danger" || "")}>
                <label htmlFor={props.id || props.name}>{label}</label>
                <div>{field.value || props.value}</div>

            </div>
        </React.Fragment>
    );
};


const CheckboxInput = ({label, children, ...props}) => {
    // React treats radios and checkbox inputs differently other input types, select, and textarea.
    // Formik does this too! When you specify `type` to useField(), it will
    // return the correct bag of props for you -- a `checked` prop will be included
    // in `field` alongside `name`, `value`, `onChange`, and `onBlur`
    const [field, meta] = useField({...props, type: 'checkbox'});

    return (
        <div className={"form-group" + (meta.touched && meta.error && " has-danger" || "")}>
            <label htmlFor={props.id || props.name}>{label}</label>
            <div className="custom-control custom-checkbox">
                <input className="custom-control-input" type="checkbox" {...field} {...props} />
                <label className="custom-control-label" htmlFor={props.id || props.name}>
                    {children}
                </label>
                {meta.touched && meta.error ? (
                    <div className="form-control-feedback">
                        * {meta.error}
                    </div>
                ) : null}

            </div>
        </div>


        // <div className="form-check">
        //     <input type="checkbox" {...field} {...props} />
        //     <label className="form-check-label" htmlFor={props.id || props.name}>
        //         {children}
        //     </label>
        // </div>


    );
};


const RadioInput = ({label, children, ...props}) => {
    // React treats radios and checkbox inputs differently other input types, select, and textarea.
    // Formik does this too! When you specify `type` to useField(), it will
    // return the correct bag of props for you -- a `checked` prop will be included
    // in `field` alongside `name`, `value`, `onChange`, and `onBlur`
    const [field, meta] = useField({...props, type: 'radio'});

    return (
        <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" {...field} {...props}/>
            <label className="form-check-label" htmlFor={props.id || props.name}>
                {label}
            </label>
        </div>


        // <div className={"form-group" + (meta.touched && meta.error && " has-danger" || "")}>
        //     <label htmlFor={props.id || props.name}>{label}</label>
        //     <div className="custom-control custom-checkbox">
        //         <input className="custom-control-input" type="checkbox" {...field} {...props} />
        //         <label className="custom-control-label" htmlFor={props.id || props.name}>
        //             {children}
        //         </label>
        //         {meta.touched && meta.error ? (
        //             <div className="form-control-feedback">
        //                 * {meta.error}
        //             </div>
        //         ) : null}
        //
        //     </div>
        // </div>


        // <div className="form-check">
        //     <input type="checkbox" {...field} {...props} />
        //     <label className="form-check-label" htmlFor={props.id || props.name}>
        //         {children}
        //     </label>
        // </div>


    );
};


const SelectInput = ({label, ...props}) => {
    const [field, meta] = useField(props);
    return (

        <React.Fragment>
            <div className={"form-group " + (meta.touched && meta.error && " has-danger" || "")}>
                <label htmlFor={props.id || props.name}>{label}</label>

                <select className={"form-control " + (meta.touched && meta.error && "form-control-danger")} {...field} {...props} />
                {meta.touched && meta.error ? (
                    <div className="form-control-feedback">
                        {meta.error}
                    </div>
                ) : null}
                {/*<small className="form-text text-muted">Example help text that remains unchanged.</small>*/}
            </div>
        </React.Fragment>

        //
        // <div>
        //     <label htmlFor={props.id || props.name}>{label}</label>
        //     <select {...field} {...props} />
        //     {meta.touched && meta.error ? (
        //         <div className="error">{meta.error}</div>
        //     ) : null}
        // </div>
    );
};


export {TextInput, CheckboxInput, TextLabel, TextArea, SelectInput, RadioInput, NewsletterSignupInput}
